import { Weight } from 'careit';

export function formatWeight(value, unit = 'lbs') {
  unit = unit ?? 'lbs';
  return new Weight(new Weight(value ?? 0, 'lbs').as(unit), unit).toString();
}
